<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Product Download',
          to: {
            name: 'ProductDownload'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'ProductDownloadEdit',
            params: {
              id: $route.params.id
            }
          }
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯Product Download</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <ProductDownloadCreateEdit></ProductDownloadCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ProductDownloadCreateEdit from '@/views/C-4__ProductDownload/c/ProductDownloadCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    ProductDownloadCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('productDownload', ['download']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getDownload(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('productDownload', {
      getDownload: 'findById',
      saveDownload: 'save',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.saveDownload(this.download).then(() => {
          this.$router.push({ name: 'ProductDownload' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
